import { toDebug } from "./debug.js";
function replace(text, replacements) {
  if (!replacements) {
    return text;
  }
  let replaced = text;
  for (const [search, replace2] of Object.entries(replacements)) {
    replaced = replaced.replaceAll(search, replace2.toString());
  }
  return replaced;
}
export function getSingleText(key, isDebug, texts, replacements) {
  if (texts) {
    const candidate = texts[key];
    if (typeof candidate === "string") {
      return toDebug(key, replace(candidate, replacements), isDebug);
    } else if (Array.isArray(candidate) && candidate[0]) {
      return toDebug(key, replace(candidate[0], replacements), isDebug);
    }
  }
  return key;
}
export function getPluralTexts(key, count, isDebug, texts, replacements) {
  if (texts) {
    const candidate = texts[key];
    if (Array.isArray(candidate) && candidate.length === 2) {
      const text = count === 1 || count === "1" ? candidate[0] : candidate[1].replace("@count", (count || 0).toString());
      return toDebug(key, replace(text, replacements), isDebug);
    }
  }
  return key;
}
